import { isFalsy } from '../../Helpers/helpers';

/**
 * Lower cases an entire string and capitlizes only the first letter of the first word
 * @function capitalizeFirstLetter
 * @param {string} str - The string to be formatted
 * @param {boolean} [preserveCase=false] - If true, the rest of the string will not be lowercased
 * @return {string}
 * @example capitalizeFirstLetter('the quick brown fox') => 'The quick brown fox'
 * @example capitalizeFirstLetter('THE DOG JUMPED') => 'The dog jumped'
 */
const capitalizeFirstLetter = (str, preserveCase) => {
  if (isFalsy(str)) return '';
  const first = str.slice(0, 1).toUpperCase();
  const rest = preserveCase ? str.slice(1) : str.slice(1).toLowerCase();
  return `${first}${rest}`;
};

export default capitalizeFirstLetter;
